import sendGtag from '@pt/utils/send-gtag.js'
import { getRefererFromStorage } from '@pt/views/login/utils'

export function handleTrial() {
  sendGtag({
    name: 'register_start',
  })

  const referer = getRefererFromStorage() || ''

  window.location.href = '/#/nl/open_register_trial?referer=' + referer
}
